import { IGlobalState } from '../../Root/store/appReducer'

export const getLoadingJoinGoal = (state: IGlobalState) => state.loading.joinGoal
export const getLoadingExport = (state: IGlobalState) => state.loading.export
